import React from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {AnalyticsFilterTypesEnum} from '../../../models/api/analyticsSavedViewModel';
import {AnalyticsPanelIdSelector} from '../../../store/panels/analytics/analyticsPanelSelectors';
import {FilterContent} from '../../helpers/filterContent';
import {useAnalyticsFilter} from '../../helpers/hooks/useAnalyticsFilter';
import {analyticsFilterColor, useFiltersTracking} from './common/helpers';

/*
 * Hook.
 */

export const useAnalyticsLiveDashboardWithWaitingFilter = (getPanelId: AnalyticsPanelIdSelector<void>) => {
  const {trackOnEdit} = useFiltersTracking(AnalyticsFilterTypesEnum.LIVE_DASHBOARD_WITH_WAITING, getPanelId);

  const [hasWaitingMetricsFilterValue, setHasWaitingMetricsFilterValue] = useAnalyticsFilter(
    AnalyticsFilterTypesEnum.LIVE_DASHBOARD_WITH_WAITING,
    getPanelId,
  );

  /*
   * Event Handlers.
   */

  const trackAndSetFilterValue = (desiredState: boolean) => {
    if (hasWaitingMetricsFilterValue === desiredState) {
      // noop, skip.
      return;
    }

    setHasWaitingMetricsFilterValue(desiredState);

    trackOnEdit([], [], {with_waiting: desiredState});
  };

  /*
   * Dropdown.
   */

  const theme = useUserTheme();

  const isActive = hasWaitingMetricsFilterValue ?? false;
  const iconName = hasWaitingMetricsFilterValue ? 'eyeFilledSmall' : 'eyeCrossedSmall';
  const iconColor = isActive ? analyticsFilterColor.findActive(theme) : analyticsFilterColor.findBase(theme);

  const renderButton = () => (
    <FilterContent iconName={iconName} iconColor={iconColor}>
      {[
        <Trans key="with-waiting-filter-include" id="with-waiting-filter-include">
          Include waiting conversations
        </Trans>,
      ]}
    </FilterContent>
  );

  return {
    id: 'live-dashboard-with-waiting-filter',
    type: AnalyticsFilterTypesEnum.LIVE_DASHBOARD_WITH_WAITING,
    isActive,
    renderButton,
    setIsActive: trackAndSetFilterValue,
  };
};
